import { Grid } from '@mui/material';
import moment from 'moment';
import { OrderEntry } from 'src/types/orderEntry';
import { Order } from 'src/types/orderList';

declare interface Props {
  order?: OrderEntry;
  openOrder?: Order;
}

const OrderDetail: React.FC<React.PropsWithChildren<Props>> = ({ order, openOrder }) => {
  return (
    <Grid size={{ xs: 12 }} sx={{ width: '100%', mt: 5, mb: 3, justifyContent: 'center', display: 'flex' }}>
      <Grid container spacing={2} style={{ width: '100%', maxWidth: '1400px', justifyContent: 'center', display: 'flex' }} className="view-order__row">
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <div className="view-order__column-divider">
            <div>
              <strong>Order #:</strong> {order && <span className="view-order__column__val pl-2 px-1">{order?.sfaOrderId ? order?.sfaOrderId : 'N/A'}</span>}
              {openOrder && <span className="view-order__column__val px-1">{openOrder?.orderNumber ? openOrder?.orderNumber : 'N/A'}</span>}
            </div>
            <div>
              <strong>Order Date:</strong>
              {order && <span className="view-order__column__val px-1">{order?.createDate ? moment(order.createDate).format('M/DD/yyyy') : 'N/A'}</span>}
              {openOrder && <span className="view-order__column__val px-1">{openOrder?.createDate ? moment(openOrder.createDate).format('M/DD/yyyy') : 'N/A'}</span>}
            </div>
            <div>
              <strong>Promised Date:</strong>
              {order && <span className="view-order__column__val px-1">{order?.promisedDate ? moment(order.promisedDate).format('M/DD/yyyy') : 'N/A'}</span>}
              {openOrder && <span className="view-order__column__val px-1">{openOrder?.promisedDate ? moment(openOrder.promisedDate).format('M/DD/yyyy') : 'N/A'}</span>}
            </div>
            <div>
              <strong>Required Date:</strong>
              {order && <span className="view-order__column__val px-1"> {order?.requiredShipDate ? moment(order.requiredShipDate).format('M/DD/yyyy') : 'N/A'}</span>}
              {openOrder && <span className="view-order__column__val px-1"> {openOrder?.requiredShipDate ? moment(openOrder.requiredShipDate).format('M/DD/yyyy') : 'N/A'}</span>}
            </div>
          </div>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <div className="view-order__column-divider">
            <div>
              <strong>Customer #:</strong>
              {order && <span className="view-order__column__val px-1">{order?.customerNumber ? order?.customerNumber : 'N/A'}</span>}
              {openOrder && <span className="view-order__column__val px-1">{openOrder?.customerNumber ? openOrder?.customerNumber : 'N/A'}</span>}
            </div>
            <div>
              <strong>Ship To:</strong>
              {order && <span className="view-order__column__val px-1">{order?.shipToName ? order?.shipToName : 'N/A'}</span>}
              {openOrder && <span className="view-order__column__val px-1">{openOrder?.shipToName ? openOrder?.shipToName : 'N/A'}</span>}
            </div>
            <div>
              <strong>Stage:</strong>
              {order && <span className="view-order__column__val px-1">{order?.stage ? order?.stage : 'N/A'}</span>}
              {openOrder && <span className="view-order__column__val px-1">{openOrder?.stage ? openOrder?.stage : 'N/A'}</span>}
            </div>
            <div>
              <strong>Term Type:</strong>
              {order && <span className="view-order__column__val px-1">{order?.termCode ? order?.sfaOrderId : 'N/A'}</span>}
              {openOrder && <span className="view-order__column__val px-1">{openOrder?.termsType ? openOrder?.termsType : 'N/A'}</span>}
            </div>
          </div>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <div className="view-order__column-divider">
            <div>
              <strong>Customer PO:</strong>
              {order && <span className="view-order__column__val px-1">{order?.customerPO ? order.customerPO : 'N/A'}</span>}
              {openOrder && <span className="view-order__column__val px-1">{openOrder?.customerPO ? openOrder.customerPO : 'N/A'}</span>}
            </div>
            <div>
              <strong>Vendor Order #:</strong>
              {order && <span className="view-order__column__val px-1">{order?.vendorOrderNo ? order.vendorOrderNo : 'N/A'}</span>}
              {openOrder && <span className="view-order__column__val px-1">{openOrder?.vendorOrderNo ? openOrder.vendorOrderNo : 'N/A'}</span>}
            </div>
            <div>
              <strong>Reference:</strong>
              {order && <span className="view-order__column__val px-1">{order?.reference ? order?.reference : 'N/A'}</span>}
              {openOrder && <span className="view-order__column__val px-1">{openOrder?.reference ? openOrder?.reference : 'N/A'}</span>}
            </div>
            <div>
              <strong>Carrier:</strong>
              {order && <span className="view-order__column__val px-1">{order?.carrier ? order?.carrier : 'N/A'}</span>}
              {openOrder && <span className="view-order__column__val px-1">{openOrder?.carrier ? openOrder?.carrier : 'N/A'}</span>}
            </div>
          </div>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <div className="view-order__column-divider">
            <div>
              <strong>On Hold:</strong>
              {order && <span className="view-order__column__val px-1">{order?.onHold ? order?.onHold : 'N'}</span>}
              {openOrder && <span className="view-order__column__val px-1">{openOrder?.onHold ? openOrder?.onHold : 'N'}</span>}
            </div>
            <div>
              <strong>Total:</strong>
              {order && <span className="view-order__column__val px-1">{order?.total ? order?.total : 'N/A'}</span>}
              {openOrder && (
                <span className="view-order__column__val px-1">
                  {openOrder?.total ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(openOrder?.total) : 'N/A'}
                </span>
              )}
            </div>
            <div>
              <strong>Total Tax:</strong>
              {order && <span className="view-order__column__val px-1">{order?.totalTax ? order?.totalTax : 'N/A'}</span>}
              {openOrder && (
                <span className="view-order__column__val px-1">
                  {openOrder?.totalTax ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(openOrder?.totalTax) : 'N/A'}
                </span>
              )}
            </div>
            <div>
              <strong>Total Freight:</strong>
              {order && <span className="view-order__column__val px-1">{order?.totalFreight ? order?.totalFreight : 'N/A'}</span>}
              {openOrder && (
                <span className="view-order__column__val px-1">
                  {openOrder?.totalFreight ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(openOrder?.totalFreight) : 'N/A'}
                </span>
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrderDetail;
